export const POST_KEY = 'post';
export const PUT_KEY = 'put';
export const DELETE_KEY = 'delete';
export const LIST_KEY = 'list';
export const ENTITY_KEY = 'entity';
export const LAST_ENTITY_BY_KEY = 'last-entity-by-key';
export const SUMMARY_KEY = 'summary';

export const DEVICE_QUERY_KEY = 'device';
export const DOCUMENT_QUERY_KEY = 'document';
export const DOCUMENT_TEMPLATE_QUERY_KEY = 'document-template';
export const DOCUMENT_SETTINGS_QUERY_KEY = 'document-settings';
export const COPY_KEY = 'copy';

export const FUEL_SURCHARGE_QUERY_KEY = 'fuel-surcharge';
export const INSURED_QUERY_KEY = 'insured';
export const COMPANY_QUERY_KEY = 'company';
export const COMPANY_WITH_EMPLOYEE_PREFERENCES_QUERY_KEY = 'company-with-employee-preferences';
export const RESET_COMPANY_ROOM_OPTION_LIST = 'reset-company-room-option-list';

export const ROOM_OPTION_LIST_QUERY_KEY = 'room-option-list';
export const ROOM_OPTION_EXPORT_QUERY_KEY = 'room-option-export';
export const DEFAULT_ROOM_OPTION_LIST_QUERY_KEY = 'default-room-option-list';
export const BASIC_COMPANY_KEY = 'basic-company';
export const ADMIN_TABLE_COMPANY_KEY = 'admin-table-company';
export const ADD_CONTACT_COMPANY_KEY = 'add-contact-company';
export const CUSTOMIZATION_QUERY_KEY = 'customization';
export const MESSAGING_QUERY_KEY = 'messaging';
export const MESSAGING_COMPANY_LOCALE_QUERY_KEY = 'messaging-locale';
export const EMPLOYEE_QUERY_KEY = 'employee';
export const EMPLOYEE_PREFERENCES_QUERY_KEY = 'employee-preferences';
export const BASIC_EMPLOYEE_KEY = 'basic-employee';
export const ADMIN_EMPLOYEE_KEY = 'admin-employee';
export const EVENTS_QUERY_KEY = 'upcoming-appointments';
export const PENDING_SELF_SURVEY_QUERY_KEY = 'pending-selF-survey';
export const JOB_QUERY_KEY = 'job';
export const PROPERTY_QUERY_KEY = 'property';
export const LOCATION_QUERY_KEY = 'location';
export const DEPRECIATION_TABLE_QUERY_KEY = 'depreciation-table';
export const TAX_RATE_QUERY_KEY = 'tax-rate';
export const JOB_UNASSIGN_KEY = 'job-unassign';
export const ITEM_QUERY_KEY = 'item';
export const ITEM_IMPORT_QUERY_KEY = 'item-import';
export const IMAGE_QUERY_KEY = 'image';
export const IMAGE_UPLOAD_MUTATION_KEY = 'image-upload';
export const VIDEO_QUERY_KEY = 'video';
export const ROOM_QUERY_KEY = 'room';
export const TIME_SLOTS_QUERY_KEY = 'time-slots';

export const TRANSCRIPT_QUERY_KEY = 'transcript';

export const FOLLOWUP_RULE_QUERY = 'followup-rule';

export const FIRST_COMPANY_KEY = 'first-company-key';

export const CUBE_FACTOR_KEY = 'cube-factor';

export const ZIP_CODES = 'zip-codes';

export const SMART_CONSULT_BACKGROUND_IMAGE_QUERY_KEY = 'smart-consult-background-image';

export const DIRECTIVE_REPORTS_QUERY_KEY = 'directive-reports';

export const PLAYBOOK_QUERY_KEY = 'playbook';
export const DIRECTIVE_QUERY_KEY = 'directive';

export const EXPORT_JOBS_CSV_QUERY_KEY = 'export-jobs-csv';

export const VEHICLE_SHIPMENT_INFO_REQUEST_QUERY_KEY = 'vehicle-shipment-info-request';
export const VEHICLE_SHIPMENT_QUERY_KEY = 'vehicle-shipment';
export const VEHICLE_OPTIONS_QUERY_KEY = 'vehicle-options';
export const VEHICLE_QUOTE_QUERY_KEY = 'vehicle-quote';
export const VEHICLE_ORDER_QUERY_KEY = 'vehicle-order';

export const LABEL_POSTPROCESSING_QUERY_KEY = 'label-postprocessing';

export const JOB_QUERY = 'job';
export const JOB_ITEM_QUERY = 'job-item';
export const JOB_CUSTOMIZATION_QUERY = 'job-customization';
export const JOB_SHARE_DOCUMENTS_MUTATION = 'job-share-documents';
